"use client";

import { useQueryState } from "nuqs";

import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { BuyPremiumConsultancy } from "@/app/_components/buy-premium-consultancy";

import { Dividas } from "./tabs/dividas";
import { Documentos } from "./tabs/documentos";
import { Processos } from "./tabs/processos";
import { Propietarios } from "./tabs/proprietarios";

import { diligenciaItems } from "./constants";
import { propertyTabSearchParam } from "@/filters";

import type { DiligenceItem } from "./diligence.types";

export const Diligence = ({ id, field, emptyElement }: DiligenceItem) => {
  const [activeTab, setActiveTab] = useQueryState(
    propertyTabSearchParam.secao,
    {
      defaultValue: "dividas",
      parse: (value) => {
        return diligenciaItems.some((item) => item.id === value)
          ? value
          : "dividas";
      },
    }
  );

  const getTabContent = () => {
    switch (activeTab) {
      case "dividas":
        return <Dividas id={id} field={field} emptyElement={emptyElement} />;
      case "documentos":
        return <Documentos id={id} field={field} emptyElement={emptyElement} />;
      case "proprietarios":
        return (
          <Propietarios id={id} field={field} emptyElement={emptyElement} />
        );
      case "processos":
        return <Processos id={id} field={field} emptyElement={emptyElement} />;
      default:
        return <Dividas id={id} field={field} emptyElement={emptyElement} />;
    }
  };

  const activeTabData =
    diligenciaItems.find((item) => item.id === activeTab) || diligenciaItems[0];

  return (
    <div className="flex flex-col sm:flex-row">
      <div className="sm:w-72 shrink-0 sm:border-r pb-10 sm:pb-0">
        <ScrollArea className="h-full sm:py-6 sm:pr-6">
          <div className="flex flex-col gap-4">
            <h2 className="px-4 text-lg font-semibold tracking-tight">
              Diligências
            </h2>
            <div className="flex flex-col gap-1">
              {diligenciaItems.map((item) => (
                <Button
                  key={item.id}
                  variant={activeTab === item.id ? "secondary" : "ghost"}
                  className="w-full justify-start px-4 py-2 text-left"
                  onClick={() => setActiveTab(item.id)}
                >
                  <div className="flex items-center gap-2">
                    <item.icon className="h-4 w-4" />
                    <span>{item.label}</span>
                  </div>
                </Button>
              ))}
            </div>
          </div>
        </ScrollArea>
      </div>
      <div className="flex flex-col gap-10 px-0 sm:pl-10 w-full">
        <div className="flex flex-col gap-2 mb-6">
          <h1 className="text-2xl font-semibold tracking-tight">
            {activeTabData.label}
          </h1>
          <p className="text-sm text-muted-foreground">
            {activeTabData.description}
          </p>
        </div>
        {getTabContent()}
        <p className="text-sm text-muted-foreground mt-6">
          Quer ter uma diligência completa e detalhada com suporte de
          especialistas?{" "}
          <BuyPremiumConsultancy>
            <Button
              variant="link"
              size="sm"
              className="text-sm p-0 min-h-0 underline"
            >
              Fale conosco!
            </Button>
          </BuyPremiumConsultancy>
        </p>
      </div>
    </div>
  );
};
